import request from '@/utils/request'

export function getAnnAdminPage(data,log) {
  return request({
    url: `/camds/announcement/page`,
    method: 'post',
    data,
    log,
  })
}

export function addAnnouncement(data,log) {
  return request({
    url: `/camds/announcement`,
    method: 'post',
    data,
    log,
  })
}

export function getAnnouncementById(id,log) {
  return request({
    url: `/camds/announcement/${id}`,
    method: 'get',
    log,
  })
}
//获取最新公告
export function getNewAnnouncement(log) {
  return request({
    url: `/camds/announcement/getNewAnnouncement`,
    method: 'get',
    log,
  })
}

// 更新公告
export function updateAnnouncement(data,log) {
  return request({
    url: `/camds/announcement`,
    method: 'put',
    data,
    log,
  })
}
// 批量删除
export function delAnnouncement(ids,log) {
  return request({
    url: `/camds/announcement/${ids}`,
    method: 'delete',
    log,
  })
}

